import { PageController } from '@client/components/_core/layout/PageController';
import { LodgementsPage } from '@client/components/lodgement/submissions/LodgementsPage';
import { lodgementsSearchSchema } from '@client/components/lodgement/submissions/lodgement-search-params';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { Inbox } from 'lucide-react';

/**
 * Claims → Lodgements (CUR-1408): every draft and submission from the organisation's lodgement
 * links, before and after it becomes a claim. Org-wide by decision (2026-09-18): the person
 * asking has a name, an email, a reference or a date — never a version.
 */
export const Route = createFileRoute('/console/$orgId/claims/lodgements')({
    staticData: {
        metadata: { title: 'Lodgements' },
        breadcrumb: { title: 'Lodgements' },
        ui: {
            title: 'Lodgements',
            subtitle: 'Drafts and submissions from your lodgement links',
            icon: Inbox,
        },
        modules: ['claim'],
        // Any one of these grants the page; the server scopes handling-party users to their versions.
        permissions: ['claim:read', 'claim:read:own_handling_parties', 'claim:read:unallocated', 'settings:update'],
        featureFlag: 'is-products-v2-enabled',
    },
    validateSearch: zodValidator(lodgementsSearchSchema),
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <LodgementsPage />
        </PageController>
    );
}
